import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
import config from '../../config';
import moment from 'moment';


class Footer extends React.Component {

    render() {
        return (
        <>
        <footer class="py-4 bg-light mt-auto">
                    <div class="container-fluid">
                        <div class="d-flex align-items-center justify-content-between small">
                            <div class="text-muted">Copyright &copy; Rozar Campus {moment().year()} </div>
                            <div>
                                <Link to="/PrivacyPolicy">Privacy Policy</Link>
                                &middot;
                                <Link to="/TermsandConditions">Terms &amp; Conditions</Link>
                            </div>
                        </div>
                    </div>
                </footer>
        </>
    )
    }
}
export default Footer
